module.exports = "<app-loading-screen></app-loading-screen>\n\n<router-outlet></router-outlet>\n"